// 所属服务 serviceTool 业务工具,publicTool 公共工具
const service = "serviceTool";
// 前台路由
const web_routers = undefined;
// 后台路由
const cms_routers = {
  path: "workflow",
  name: "workflow",
  component: () =>
    import(
      /* webpackChunkName: "[request]" */ "../layouts/backstage/WorkflowLayout.vue"
    ),
  redirect: { name: "formManagement" },
  meta: {
    title: "表单管理",
  },
  children: [
    {
      path: "formManagement",
      name: "formManagement",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../view/backstage/formManagement/Index.vue"
        ),
      meta: {
        title: "表单管理",
        icon: "icon-wendang",
      },
    },
    {
      path: "formManagementCreate",
      name: "formManagementCreate",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../view/backstage/formManagementCreate/Index.vue"
        ),
      meta: {
        title: "表单创建",
        layout: false,
        head: false,
      },
    },
    {
      path: "formSummary",
      name: "formSummary",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../view/backstage/formSummary/Index.vue"
        ),
      meta: {
        title: "表单汇总",
        icon: "icon-shuju1",
      },
    },
    {
      path: "formPreview",
      name: "formPreview",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../view/backstage/formPreview/Index.vue"
        ),
      meta: {
        title: "表单预览",
        layout: false,
      },
    },
    {
      path: "processMonitor",
      name: "processMonitor",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../view/backstage/processMonitor/Index.vue"
        ),
      meta: {
        title: "流程监控",
        icon: "icon-diannao2",
      },
    },
    {
      path: "processMonitorDetail",
      name: "processMonitorDetail",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../view/backstage/processMonitorDetail/Index.vue"
        ),
      meta: {
        title: "监控详情",
        layout: false,
      },
    },
    {
      path: "approvalManagement",
      name: "approvalManagement",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../view/backstage/approvalManagement/Index.vue"
        ),
      meta: {
        title: "流程管理",
        icon: "icon-liucheng",
      },
    },
    {
      path: "approvalManagementCreate",
      name: "approvalManagementCreate",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../view/backstage/approvalManagementCreate/Index.vue"
        ),
      meta: {
        title: "流程创建",
        layout: false,
        head: false,
      },
    },
  ],
};
export default {
  service,
  web: web_routers,
  cms: cms_routers,
};
